module.exports = __webpack_public_path__ + "img/form@2x.c82ed8f.webp";